import React from 'react';

function DirectorRequestFilters({
  requestSearch = '',
  requestTypeFilter = 'all',
  setRequestSearch = () => {},
  setRequestTypeFilter = () => {}
}) {
  return (
    <div className="director-toolbar">
      <div className="director-toolbar-group">
        <label>Request Type</label>
        <div className="director-filter-chip-row">
          <button
            type="button"
            className={`director-filter-chip ${requestTypeFilter === 'all' ? 'active' : ''}`}
            onClick={() => setRequestTypeFilter('all')}
          >
            All
          </button>
          <button
            type="button"
            className={`director-filter-chip ${requestTypeFilter === 'pto' ? 'active' : ''}`}
            onClick={() => setRequestTypeFilter('pto')}
          >
            PTO
          </button>
          <button
            type="button"
            className={`director-filter-chip ${requestTypeFilter === 'attendance' ? 'active' : ''}`}
            onClick={() => setRequestTypeFilter('attendance')}
          >
            Attendance
          </button>
        </div>
      </div>
      <div className="director-toolbar-group director-toolbar-search">
        <label htmlFor="request-search">Search Requests</label>
        <input
          id="request-search"
          value={requestSearch}
          onChange={(event) => setRequestSearch(event.target.value)}
          placeholder="Person, location, reason, status..."
        />
      </div>
    </div>
  );
}

export default DirectorRequestFilters;
